<template>
  <component
    :is="manualInput ? 'v-combobox' : 'v-autocomplete'"
    :items="locations"
    :label="label"
    :placeholder="placeholder"
    :value="value"
    :multiple="multiple"
    :clearable="clearable"
    :outlined="outlined"
    :dense="dense"
    :hide-details="hideDetails"
    :item-text="(item) => `${item.location_id} - ${item.name}`"
    :item-value="manualInput ? undefined : 'location_id'"
    :return-object="returnObject"
    :no-data-text="$t('components.select.noDataText')"
    @change="handleSelectionChange"
    :error-messages="errorMessages"
  >
    <template v-slot:prepend-item v-if="locations.length && selectAll">
      <v-list-item ripple @click.stop="selectAllLocations()">
        <v-list-item-action>
          <v-icon v-if="!allLocationsSelected" color="primary darken-2">mdi-select</v-icon>
          <v-icon v-else color="primary darken-1">mdi-select-all</v-icon>
        </v-list-item-action>
        <v-list-item-title v-if="!allLocationsSelected">{{ $t('location.selectAll') }}</v-list-item-title>
        <v-list-item-title v-else>{{ $t('location.removeAll') }}</v-list-item-title>
      </v-list-item>
    </template>
    <template v-if="multiple" v-slot:selection="{ item, index }">
      <v-chip small v-if="index === 0">
        <span v-if="item.location_id">{{ `${item.location_id} - ${item.name}` }}</span>
        <span v-else>{{ `${item}` }}</span>
      </v-chip>
      <span v-if="index === 1" class="grey--text caption">
        {{ `(+${numberSelected - 1} ${$t('components.select.others')})` }}
      </span>
    </template>
  </component>
</template>

<script lang="js">
  import { LocationService } from '../services/locationService';

  export default {
    name: 'OSelectLocations',
    props: {
      items: {
        type: Array,
        default: null
      },
      manualInput: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      },
      outlined: {
        type: Boolean,
        default: false
      },
      dense: {
        type: Boolean,
        default: true
      },
      clearable: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ""
      },
      placeholder: {
        type: String,
        default: ""
      },
      value: {
        type: [String, Array, Object],
        default: () => {
          return this.multiple ? [] : null
        }
      },
      returnObject: {
        type: Boolean,
        default: false
      },
      errorMessages: {
        type: [String, Array],
        default: () => []
      },
      selectAll: {
        type: Boolean,
        default: false
      },
      hideDetails: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        locations: this.items ?? [],
      };
    },
    async mounted() {
      if (!this.items) {
        const res = await LocationService.getLocations(this.$auth.accessToken, {
          itemsPerPage: false,
          fields: ['location_id', 'name'],
        })
        this.locations = res?.data ?? []
      }
    },
    computed: {
      numberSelected() {
        const fallbackValue = this.value ? 1 : 0
        return Array.isArray(this.value) ? this.value.length : fallbackValue
      },
      allLocationsSelected() {
        return Array.isArray(this.value) && this.locations.length > 0 && this.value.length === this.locations.length
      }
    },
    methods: {
      handleSelectionChange(event) {
        this.$emit('input', event?.location_id && !Array.isArray(event) ? event.location_id : event)
      },
      selectAllLocations() {
        if (this.allLocationsSelected) {
          return this.handleSelectionChange([])
        }
        const all = this.locations.map((loc) => this.returnObject ? loc : loc.location_id)
        return this.handleSelectionChange(all)
      },
    },
    watch: {
      items(newVal) {
        if (newVal) {
          this.locations = newVal
        }
      }
    }
  };
</script>
